import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
  const _component_el_descriptions = _resolveComponent("el-descriptions");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_descriptions, {
    title: _ctx.notice.noticeName,
    column: 1,
    border: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
      label: "发布时间"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.notice.startTime), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      label: "公告内容"
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        innerHTML: _ctx.notice.noticeContent
      }, null, 8, _hoisted_1)]),
      _: 1
    })]),
    _: 1
  }, 8, ["title"])]);
}